import { BlockDataForm } from '@plone/volto/components/manage/Form';
import PropTypes from 'prop-types';

import DateShareSchema from './schema';

const DateShareData = (props) => {
  const { data, block, onChangeBlock, blocksErrors } = props;

  const schema = DateShareSchema({ ...props });
  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
      errors={blocksErrors}
    />
  );
};

DateShareData.propTypes = {
  data: PropTypes.shape({
    hideDate: PropTypes.bool,
    hideShare: PropTypes.bool,
  }),
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
};

export default DateShareData;
